import React from 'react'
import '../../Styles/testimonial.css'
import { MdOutlineStar } from "react-icons/md";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
};


function AboutTestimonail() {

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "80px",
    slidesToShow: 3,
    speed: 500,
    dots: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

  };

  return (
    <>
      <div className="about_us_main_testimonial">

        <div className="container testimonail_main">
          <div className="about_testimonial_header_main">
            <h2>Testimonials</h2>
            <h6 className='' >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of typ,</h6>
          </div>

          <div className="about_testimonial_client_info">
            <div className="d-flex align-items-center justify-content-center">
              <MdOutlineStar />
              <MdOutlineStar />
              <MdOutlineStar />
              <MdOutlineStar />
              <MdOutlineStar />
            </div>
            <div className='my-xl-5 about_testimonial_slider d-flex align-items-center justify-content-center' >
              <img src="/images/user5.png" alt="img" />
              <div className='mx-3' >
                <h2>Clevia Thomas</h2>
                <p className='m-0' >Real Estate Manager</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default AboutTestimonail
